import { ArrowUpRight, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { MaskLines, Reveal, SectionLabel } from "./Motion";
import { useT } from "@/i18n";

const GROUPS = [
  ["apps", "Campi di applicazione", ["Grandi luci senza appoggi intermedi", "Travi curve e forme libere", "Edilizia multipiano", "Coperture, solai e strutture speciali", "Ponti e passerelle"]],
  ["sectors", "Settori d'impiego", ["Edilizia pubblica e scolastica", "Impianti sportivi e piscine", "Edilizia residenziale", "Edifici industriali e commerciali", "Luoghi di culto, cultura e turismo"]],
  ["edge", "Vantaggi competitivi", ["Elevata capacità portante", "Stabilità dimensionale", "Libertà di configurazione", "Resistenza al fuoco", "Materiale sostenibile e rinnovabile"]],
];

const Group = ({ id, title, items, i, t }) => (
  <Reveal delay={i * 0.1} className="border-t border-[#121110]/15 pt-6" data-testid={`lamellare-group-${id}`}>
    <span className="font-mono text-xs text-[#9A5326]">0{i + 1}</span>
    <h3 className="mt-3 font-display text-2xl font-bold tracking-tight">{t(`lam.${id}.t`, title)}</h3>
    <ul className="mt-5 space-y-3">
      {items.map((it, k) => (
        <li key={it} className="flex gap-3 text-sm leading-relaxed text-[#3D3833] sm:text-base">
          <Check className="mt-1 h-4 w-4 shrink-0 text-[#C26D38]" /> {t(`lam.${id}.${k}`, it)}
        </li>
      ))}
    </ul>
  </Reveal>
);

export const LamellareIntro = () => {
  const t = useT();
  return (
    <section id="legno-lamellare" className="bg-[#F7F5F0] px-5 py-24 text-[#121110] sm:px-8 lg:py-32" data-testid="lamellare-section">
      <div className="mx-auto max-w-[1500px]">
        <SectionLabel index="EI">{t("lam.label", "Legno lamellare strutturale")}</SectionLabel>
        <div className="mt-10 grid gap-10 lg:grid-cols-12 lg:items-end">
          <MaskLines
            className="font-display text-3xl font-bold leading-[1.05] tracking-tight sm:text-4xl lg:col-span-7 lg:text-5xl"
            lines={[t("lam.h2a", "Il supporto in legno per l'ingegneria"), <span key="b">{t("lam.h2b", "e le")} <em className="font-serif font-normal text-[#C26D38]">{t("lam.h2em", "grandi strutture.")}</em></span>]}
          />
          <Reveal delay={0.2} className="max-w-md text-base leading-relaxed text-[#3D3833] sm:text-lg lg:col-span-5">
            {t("lam.intro", "Il legno lamellare EMMA INDUSTRIE unisce elevata capacità portante e stabilità dimensionale: la soluzione per progettisti e imprese che lavorano con grandi luci, forme curve ed edilizia multipiano.")}
          </Reveal>
        </div>
        <Reveal className="mt-16 border-l-2 border-[#C26D38] pl-6" data-testid="lamellare-claim">
          <p className="font-serif text-2xl italic leading-snug text-[#121110] sm:text-3xl lg:text-4xl">{t("lam.claim", "Ogni lamella è selezionata e prodotta per resistere generazioni.")}</p>
        </Reveal>
        <div className="mt-16 grid gap-12 md:grid-cols-3">
          {GROUPS.map(([id, title, items], i) => <Group key={id} id={id} title={title} items={items} i={i} t={t} />)}
        </div>
        <Link to="/legno-lamellare" className="btn-amber mt-14 w-fit" data-testid="lamellare-page-link">
          {t("lam.page", "Scheda tecnica, classi di resistenza e FAQ")} <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  );
};
